import * as React from 'react';

import s from './Quote.module.scss';

export interface QuoteProps {
    content: string;
    name?: string;
    color?: string;
}

const Quote: React.FC<QuoteProps> = ({ content, name, color }) => {
    const colorStyle = color ? { color } : {};
    return (
        <div className={s.Root}>
            <div className={s.Quote} style={colorStyle}>
                "{content}"
            </div>
            <h4 className={s.Name}>
                {name}
            </h4>
        </div>
    );
};

export default Quote;
